<template>
    <report-wrapper>
        <template v-slot:title>
            Balance Sheet CSV Reports
        </template>

        <div class="text-left">
            <b-form-row>
                <b-col md="3" class="my-2">
                    <ay-select v-model="aySelected" :ay-default="isReviewer ? currentAy : null" />
                </b-col>
            </b-form-row>

            <b-form-row class="mt-4">
                <b-col xmd="3" class="my-2">
                    <b-button variant="primary" @click="downloadCsv('BalanceSheetByCollege')">
                        Download CSV
                    </b-button>
                    <span class="ml-4 lead">
                        Balance Sheet By College
                    </span>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col xmd="6" class="my-2">
                    <b-button variant="primary" @click="downloadCsv('BalanceSheetByCollegeDetail')">
                        Download CSV
                    </b-button>
                    <span class="ml-4 lead">
                        Balance Sheet By College Detail
                    </span>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col md="6" class="my-2">
                    <b-button variant="primary" @click="downloadCsv('BalanceSheetByCostType')">
                        Download CSV
                    </b-button>
                    <span class="ml-4 lead">
                        Balance Sheet By Cost Type
                    </span>
                </b-col>
            </b-form-row>
        </div>
    </report-wrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import ReportWrapper from './ReportWrapper';

export default {
    name: 'BalanceSheets',

    metaInfo() {
        return { title: 'BalanceSheets' };
    },

    components: {
        'report-wrapper': ReportWrapper,
    },

    data() {
        return {
            aySelected: null,
        };
    },

    computed: {
        ...mapGetters({
            currentAy: 'ref/global/currentAy',
            isReviewer: 'auth/isReviewer'
        }),
    },

    methods: {
        downloadCsv(report) {
            // <host>/api/v1/reports?name=BalanceSheetByCollege&ay=22&fmt=csv
            const url = process.env.VUE_APP_API_URL + 'reports' +
                '?name=' + report +
                '&ay=' + this.aySelected +
                '&fmt=csv';
            window.open(url, '_blank');
        },
    },

};
</script>

<style scoped lang="scss">
</style>
